export const VALIDATION_ROWS = [
  { k: "platform", v: "NVIDIA DGX Spark · GB10 · aarch64" },
  { k: "engine", v: "Isaac Sim 6.0.1 · PhysX 6-DOF" },
  { k: "bridge reachability", v: "ping → ok", pass: true },
  { k: "hover · finite & level", v: "imu_az = 9.81 m/s²", pass: true },
  { k: "Isaac ⇄ analytic altitude", v: "Δ < 0.5 m over hover", pass: true },
  { k: "camera frame", v: "RGBA · GB10 render", pass: true },
] as const;

export const VALIDATION_TOTAL = {
  k: "suite",
  v: "4 / 4 green",
  pass: true,
} as const;

export const TWIN_CARDS = [
  {
    big: "< 0.5 m",
    title: "Simulator meets the math.",
    body: "Over the hover window, Isaac's PhysX altitude tracks our deterministic 6-DOF analytic model to within half a metre — the GPU simulation and first principles agree.",
  },
  {
    big: "6-DOF",
    title: "Real rigid-body dynamics.",
    body: "Not a lumped curve fit: full body pose and orientation, native IMU, ground contact and per-rotor wrench — the same interface a real flight stack sees.",
  },
] as const;
